import React from "react";

const MapComponentSkeleton = () => {
  return (
    <div className="listingSection__wrap">
      {/* Title Skeleton */}
      <div>
        <h2 className="text-2xl font-semibold bg-gray-300 h-6 w-36 rounded-md animate-pulse mb-2" aria-hidden="true"></h2>
        <span className="sr-only"></span> {/* Accessible content */}
        <span className="block bg-gray-300 h-4 w-52 rounded-md animate-pulse" aria-hidden="true"></span>
      </div>
      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 my-4"></div>

      {/* Map Skeleton */}
      <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3 ring-1 ring-black/10 rounded-xl overflow-hidden">
        <div className="w-full h-full bg-gray-300 animate-pulse rounded-xl" aria-hidden="true"></div>
      </div>
    </div>
  );
};

export default MapComponentSkeleton;